import type { HtmlHTMLAttributes, PropsWithChildren } from 'react';
import { memo } from 'react';

import classNames from 'classnames';

import type { CssMeasure } from '@utilities/helpers/css';

import styles from './styles.module.scss';

type CardRadius = 'medium' | 'large';
type CardPadding = 'small' | 'medium' | 'large' | 'none';

export type CardVariant = 'default' | 'accent';

interface CardProps {
  variant?: CardVariant;
  radius?: CardRadius;
  padding?: CardPadding;
  width?: CssMeasure;
  height?: CssMeasure;
  minWidth?: CssMeasure;
  minHeight?: CssMeasure;
  maxWidth?: CssMeasure;
  maxHeight?: CssMeasure;
  className?: string;
  showPlaceholder?: boolean;
  onClick?: HtmlHTMLAttributes<HTMLDivElement>['onClick'];
}

const Card = memo(
  ({
    variant = 'default',
    radius = 'medium',
    padding = 'medium',
    width,
    height,
    minWidth,
    minHeight,
    maxWidth,
    maxHeight,
    children,
    className,
    showPlaceholder = false,
    onClick,
  }: PropsWithChildren<CardProps>) => {
    return (
      <div
        data-variant={variant}
        data-radius={radius}
        data-padding={padding}
        onClick={onClick}
        className={classNames(className, styles.card, showPlaceholder && styles.placeholder)}
        style={{
          width,
          height,
          minWidth,
          minHeight,
          maxWidth,
          maxHeight,
        }}
      >
        {!showPlaceholder && children}
      </div>
    );
  },
);

export { Card, type CardProps };
